import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
// import UpdateInfo from './views/UpdateInfo.vue'
const UpdateInfo = () => import('./views/UpdateInfo.vue')

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/download',
      component: UpdateInfo,
      props: (route) => ({
        fw_commit_hash: route.query.ver,
        hardware_type: route.query.hw
      })
    },
    {
      path: '/',
      name: 'home',
      component: Home
    }
  ]
})
